<template lang="pug">
component.percentage-input(
  v-model="percent"
  :is="type"
  :step="step"
  :min="min"
  :max="max"
  type="number"
  ref="input"
  v-bind="$attrs")
  slot(name="append" slot="append")
</template>

<script>
import numeral from 'numeral'

export default {
  name: 'PercentageInput',

  props: {
    type: {
      type: String,
      default: 'el-input'
    },

    value: {
      type: [Number, String],
      default: null
    },

    step: {
      type: Number,
      default: 0.01
    },

    min: {
      type: Number,
      default: () => undefined
    },

    max: {
      type: Number,
      default: () => undefined
    }
  },

  data () {
    let percent = null
    if (typeof this.value === 'number' || typeof this.value === 'string') {
      percent = numeral(this.value).multiply(100).value()
    }
    return {
      percent
    }
  },

  watch: {
    value () {
      if (this.percent !== this.value * 100) {
        if (this.value !== null) {
          this.percent = numeral(this.value).multiply(100).value()
        }
      }
    },

    percent (a, b) {
      if (a !== b) {
        if (!this.percent) this.percent = 0
        this.$emit('input', numeral(this.percent).divide(100).value())
      }
    }
  },

  methods: {
    focus () {
      if (this.$refs.input) this.$refs.input.focus()
    }
  }

}
</script>
